import { Column, Loader, Row, Section } from "best-common-react";
import React, { useEffect, useState } from "react";
import { getAdminPurchaseOpportunityEntriesForUser } from "../../api/RequesTixApi";
import { AdminPurchaseOpportunityEntryDTO, PurchaseOpportunityDTO } from "../../types/PurchaseOpportunity";
import AdminPurchaseOpportunityGameForm from "./AdminPurchaseOpportunityGameForm";

type AdminPurchaseOpportunityRequestActionsProps = {
  opportunity: PurchaseOpportunityDTO;
  userId: number | string;
  formChanged: boolean;
};

const AdminPurchaseOpportunityRequestActions: React.FC<AdminPurchaseOpportunityRequestActionsProps> = ({
  opportunity,
  userId,
  formChanged,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [entries, setEntries] = useState<AdminPurchaseOpportunityEntryDTO[]>([]);

  const fetchAdminOpportunityEntries = async () => {
    try {
      setLoading(true);
      const res: AdminPurchaseOpportunityEntryDTO[] = await getAdminPurchaseOpportunityEntriesForUser(
        opportunity?.purchaseOpportunityId!,
        userId,
      );
      setEntries(res);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!!opportunity?.purchaseOpportunityId) {
      void fetchAdminOpportunityEntries().catch(console.error);
    }
  }, [opportunity]);

  return (
    <div>
      <Section sectionKey="admin-actions" header="Admin" showToggle={false}>
        {loading && entries.length === 0 ? (
          <Loader type="spinner" size="40px" />
        ) : (
          <Row>
            {[...entries]
              .sort((a, b) => a.gameNumber - b.gameNumber)
              .map((e: AdminPurchaseOpportunityEntryDTO) => (
                <Column width={2} key={e.purchaseOpportunityGameId}>
                  <AdminPurchaseOpportunityGameForm
                    entry={e}
                    refresh={fetchAdminOpportunityEntries}
                    formChanged={formChanged}
                  />
                </Column>
              ))}
          </Row>
        )}
      </Section>
    </div>
  );
};

export default AdminPurchaseOpportunityRequestActions;
